

// Generated class Entity_ManagedObject

class Entity_ManagedObject extends MIOManagedObject
{
}
